// extracted by mini-css-extract-plugin
export var quillEditor = "_jc-1";
export var variable = "_jc-0";